<template>
  <div class="module">
    <top class="module_top" :show="true"></top>
    <div class="budget">
      <div class="budget-top">公司介绍</div>
      <div class="budget-center">
        <div class="budget-center__detail">
          江门市链想力科技有限公司是一家专注跨境电商数据分析及数据运营系统开发的科技公司。旨在赋能中小跨境电商卖家及出口企业优化操作流程，提升运营效率，降低人力成本，提高数据准确率及数据综合运营能力，最大程度地控制损失风险。本公司所开发的系统基于多年积累的跨境电商实战运营及管理经验，不断钻研，狠抓实用性，简单易用，实战性强。
        </div>
        <div class="budget-center__detail">
          目前公司已开发项目包括亚马逊FBA产品利润预核算系统，能真正解决了亚马逊FBA卖家站内站外一体化准确计算产品及店铺利润的难题，有利于协助选品时进行快速的利润预算及核算每月汇总产品及店铺的利润。
        </div>
        <div class="budget-center__detail">
          另外，公司计划在2023年初推出亚马逊多店铺运营管理系统 (简称: 护航鲸ERP)，其将为广大亚马逊店铺卖家提供FBA商品选品利润预算，售中运营数据动态分析，售后利润核算，快速进销存财管理，跨境物流在线计价及订购等功能服务。欢迎注册免费试用及随时提出宝贵意见及建议！
        </div>
      </div>
      <div class="budget-bottom">
        <div class="budget-bottom__title">联系我们</div>
        <div class="budget-bottom__detail">
          <img src="./img/公司.png" alt="">
          <span>公司:江门市链想力科技有限公司</span>
        </div>
        <div class="budget-bottom__detail">
          <img src="./img/信封.png" alt="">
          <span>邮箱:info@whaleerp.com</span>
        </div>
        <div class="budget-bottom__detail">
          <img src="./img/信封-开-实.png" alt="">
          <span>网站:www.whaleERP.com</span>
        </div>
        <div class="budget-bottom__detail">
          <img src="./img/电话.png" alt="">
          <span>电话:0750-3228845</span>
        </div>
        <div class="budget-bottom__detail">
          <img src="./img/地址.png" alt="">
          <span>公司地址:江门市蓬江区胜利路152号1幢自编2号楼第4层</span>
        </div>
      </div>
      <div class="budget-img">
        <!-- <img src="../../assets/img/logo.png" alt=""> -->
        <!-- <img src="../../assets/img/menuHead.png"> -->
        <img src="./img/shark.png" alt="">
      </div>

    </div>
    <copyright class="copyright"></copyright>
  </div>
</template>

<script>
  import top from "@/components/content/top";
  import copyright from "@/components/content/copyright";
  export default {
      name: "introduce",
      components: {
        'top': top,
        'copyright': copyright,
      },
    }
</script>

<style scoped lang="scss">
  .budget{
    min-width: 1220px;
    min-height: 600px;
    background-color: #fff;
    border-radius: 5px;
    padding: 10px;
    box-shadow: 3px 5px 4px 2px rgba(0, 0, 0, .2);
    margin: 30px auto 10px auto;
    width: 1000px;
    position: relative;
    &-top{
      color: #19ACFD;
      font-weight: bold;
      font-size: 20px;
      border-bottom: 0.5px solid #E6E6E6;
      padding: 50px 0 10px 20px;
    }
    &-center{
      margin: 10px 40px;
      color: #a8a8a8;
      font-size: 14px;
      &__detail{
        margin: 0 0 30px 0;
        line-height: 30px;
      }
    }
    &-bottom{
      color: #a8a8a8;
      margin: 10px 40px;
      &__title{
        font-weight: bold;
        font-size: 16px;
      }
      &__detail{
        display: flex;
        align-items: center;
        margin: 20px 0;
        font-size: 13px;
      }
      &__detail span{
        margin: 0 0 0 20px;
      }
    }
    &-img{
      position: absolute;
      right: 70px;
      bottom: 65px;
    }
    &-img img{
      width: 200px;
    }
  }
  .module{
    width: 100%;
    min-width: 1600px;
    height: 100%;
    background-color: #f1f4ff;
  }

  .module_top{
    background-color: #022028;
    padding: 0 200px;
  }

  .copyright{
    margin: 20px;
  }

  @media screen and (max-width: 1600px){
    .module{
      min-width: 120rem;
    }

    .module_top{
      padding: 0 1rem;
    }
  }

  @media screen and (min-width: 1600px){
    .module{
      min-width: 1600px;
    }

    .module_top{
      padding: 0 200px;
    }
  }

  @media screen and (max-width: 1200px){
    .module_top{
      width: 132rem;
    }
  }
</style>
